import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { isNullOrUndefined } from 'util';
import { Constants } from '../constants/constants';
import { EnrollmentConstants } from '../constants/enrollment-constants';
import { MessageConstants } from '../constants/message-constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';
import { VehicleService } from '../service/vehicle.service';

const PAGE_SIZE: number = 25;
const CHECKBOX: string = "checkbox";

@Component({
  selector: 'app-account-packages',
  templateUrl: './account-packages.component.html',
  styleUrls: ['./account-packages.component.scss']
})
export class AccountPackagesComponent implements OnInit {

  //Pagination variables
  previousPage: number;
  nextPage: number;

  selectedPackages: Array<any> = [];
  pkgList: Array<any> = [];
  @ViewChild('accountPackagesForm', { static: true }) public accountPackagesForm: NgForm;
  @Output() submitEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() backEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Input() selectedVehicles;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService,
    private toastService: ToastService, private vehicleService: VehicleService) { }

  ngOnInit(): void {
    // this.init();
  }

  init(){
    this.getPackageList();
  }

  getPackageList() {
    this.utilService.showSpinner();
    this.apiService.getAccountPackages().then((data) => {
      this.utilService.hideSpinner();
      // this.pkgList = this.accountServicePackage.setPackageRatePlan(data);
      this.initAccountPackagesModel(data);
      console.log("service packages from API::", this.pkgList);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPackageList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initAccountPackagesModel(accountPackages) {
    this.pkgList = accountPackages;
    this.initSelectedPackages();
  }

  
  initSelectedPackages(){
    this.selectedPackages = this.pkgList.filter(pkg => pkg.isDefault == true);
  }

  onPackageSelectionChange(checked: boolean, packageObject: any) {
    
    var packageObjectIndex = this.selectedPackages.findIndex(p => p.accountServicePackageId === packageObject.accountServicePackageId);

    if (checked && packageObjectIndex == -1) {
      this.selectedPackages.push(packageObject);
    } else if (!checked && packageObjectIndex >= 0) {
      this.selectedPackages.splice(packageObjectIndex, 1);
    }
  } 

  resetAccountPackages(isBack: boolean = false) {
    this.selectedPackages = [];
    this.pkgList = [];
    
    this.accountPackagesForm.reset();
    this.accountPackagesForm.resetForm();

    if(!isBack)
      this.cancelEmitter.emit();
    // this.resetCheckbox();
  }

  /* resetCheckbox() {
    var items = document.getElementsByName(CHECKBOX);
    
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == CHECKBOX)
        items[i]["checked"] = false;
    }

    this.cancelEmitter.emit();
  } */

  submitAccountPackages(form: NgForm) {

    this.accountPackagesForm = form;
    // if (form.valid && this.selectedPackages.length > 0) {
    if (form.valid) {
      this.submitEmitter.emit(this.selectedPackages);
      // document.getElementById("closeAccountPackages").click();
    }
  }

  backAccountPackages() {
    this.resetAccountPackages(true);
    this.backEmitter.emit();
  }

}
